// reactstrap components
import { NavItem, NavLink, Nav, Container, Row, Col } from "reactstrap";

import { appVersion } from '../../../env'

function PageAuthFooter() {
  return (
    <>
      <footer className="py-5" id="footer-main">
        <Container>
          <Row className="align-items-center justify-content-xl-between">
            <Col xl="6">
              <div className="copyright text-center text-xl-left text-muted">
              v{appVersion()} © {new Date().getFullYear()}{" "}
                <a
                  className="font-weight-bold ml-1"
                  href="https://www.pinapromo.co.nz"
                  target="_blank" rel="noreferrer"
                >
                  Pin A Promo
                </a>
              </div>
            </Col>
            <Col xl="6">
              <Nav className="nav-footer justify-content-center justify-content-xl-end">
                <NavItem>
                </NavItem>
                <NavItem>
                  <NavLink
                    href="https://www.pinapromo.co.nz"
                    target="_blank"
                  >
                    About Us
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    href="https://blog.pinapromo.co.nz/"
                    target="_blank"
                  >
                    Blog
                  </NavLink>
                </NavItem>
              </Nav>
            </Col>
          </Row>
        </Container>
      </footer>
    </>
  );
}

export default PageAuthFooter;
